import { render, staticRenderFns } from "./Combined.vue?vue&type=template&id=1c84527e&scoped=true&"
import script from "./Combined.vue?vue&type=script&lang=js&"
export * from "./Combined.vue?vue&type=script&lang=js&"
import style0 from "./Combined.vue?vue&type=style&index=0&id=1c84527e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c84527e",
  null
  
)

export default component.exports